export const formStyle = {
  '& .MuiOutlinedInput-root': { borderRadius: '4px', bgcolor: 'common.white' },
  '& .MuiOutlinedInput-input': { height: '1em' },
};

export const buttonStyle = {
  fontSize: '12px',
  lineHeight: 1.2,
  p: 1,
  '&.MuiButton-outlined': { bgcolor: 'common.white' },
};

export const selectedTabStyle = {
  '.react-tabs__tab--selected': {
    color: 'info.main',
    textDecoration: 'underline',
    textDecorationThickness: '1.5px',
    textUnderlineOffset: '4px',
  },
};

export const cardStyle = {
  padding: 2,
  borderRadius: 1,
  mt: 1,
  mb: 2,
  width: '100%',
};

export const formCardStyle = {
  ...cardStyle,
  scrollMarginTop: '100px',
  position: 'relative',
  py: 3,
  px: { xs: 4, sm: 8 },
};

export const groupedFieldsStyle = {
  padding: '10px',
  border: '1px solid lightGrey',
  borderRadius: 1,
};
